import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PP = "'Poppins', sans-serif";

export default function QuizGateNotice() {
    const navigate = useNavigate();

    return (
        <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
            <Paper sx={{ maxWidth: 480, width: '100%', p: { xs: 3, md: 5 }, borderRadius: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', textAlign: 'center' }}>
                <Typography sx={{ fontSize: '1.25rem', fontWeight: 700, color: '#0F172A', fontFamily: PP, mb: 2 }}>
                    Certification required
                </Typography>
                <Typography sx={{ fontSize: '0.9rem', color: '#374151', fontFamily: PP, mb: 3 }}>
                    You need to pass the RSC certification quiz before you can create sales.
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate('/quiz')}
                    sx={{ fontFamily: PP, textTransform: 'none' }}
                >
                    Go to quiz
                </Button>
            </Paper>
        </Box>
    );
}
